/* ============================================================
   OMES — Gift Card Builder (Shopify section script)
   Live themed-card configurator. One instance per section.
   - Denominations + variant ids come from the {% schema %} blocks
     (rendered as .gc-denom[data-amount][data-variant]).
   - Customisation posts as native Shopify line-item properties
     (properties[...]) so the photo upload uses Shopify's built-in
     file handling — the form is multipart and submitted normally.
   ============================================================ */
(function () {
  'use strict';

  /* themed presets — visual only; occasion copy can be overridden per
     block via data-occasion on the matching thumb if desired. */
  /* image designs carry img:true + their native aspect ratio; their artwork
     comes from --gc-<id>-front/back CSS vars + per-theme coords in the CSS. */
  var THEMES = [
    { id:'omes',       name:'Omes',         tag:'Crème',     occ:'Le cadeau qui laisse le choix', img:true, ratio:'642/793' },
    { id:'editoriale', name:'Éditoriale',   tag:'Chic',      occ:'Le cadeau qui laisse le choix', img:true, ratio:'711/551' },
    { id:'synthwave',  name:'Synthwave',    tag:"80's",      occ:'Le cadeau qui laisse le choix', img:true, ratio:'656/558' },
    { id:'funky',    name:'Funky',        tag:'Playful',   occ:'Bonne fête !' },
    /* on-brand code-drawn set (shared anatomy; per-design bg/fg/mark/art) */
    { id:'noir',      name:'Noir',      tag:'Officiel',  code:true, ratio:'3/2', bg:'#0d0d0f', fg:'#ffffff', mark:'#FF3B26', art:'corner' },
    { id:'blanc',     name:'Blanc',     tag:'Signature', code:true, ratio:'3/2', bg:'#FBFAF8', fg:'#0d0d0f', mark:'#FF3B26', art:'corner' },
    { id:'diagonale', name:'Diagonale', tag:'Graphique', code:true, ratio:'3/2', bg:'#0d0d0f', fg:'#ffffff', mark:'#FF3B26', art:'diagonal' },
    { id:'motif',     name:'Motif',     tag:'Pattern',   code:true, ratio:'3/2', bg:'#0d0d0f', fg:'#ffffff', mark:'#FF3B26', art:'pattern' },
    { id:'scarlet',   name:'Scarlet',   tag:'Pop',       code:true, ratio:'3/2', bg:'#FF3B26', fg:'#ffffff', mark:'#ffffff', art:'corner' },
    { id:'creme',     name:'Crème',     tag:'Chaud',     code:true, ratio:'3/2', bg:'#FFFBE4', fg:'#181C31', mark:'#FF3B26', art:'corner' },
    { id:'marine',    name:'Marine',    tag:'Nuit',      code:true, ratio:'3/2', bg:'#02105C', fg:'#ffffff', mark:'#FF3B26', art:'corner' },
    { id:'brume',     name:'Brume',     tag:'Doux',      code:true, ratio:'3/2', bg:'#F3F4F7', fg:'#181C31', mark:'#FF3B26', art:'corner' }
  ];

  function motif(id) {
    switch (id) {
      case 'funky':
        return '<span class="blob-a"></span><span class="blob-b"></span><span class="blob-c"></span>';
      case 'birthday': {
        var dots = [
          ['14','12','3.5','#FF3B26'],['52','10','4','#c9a45c'],['68','13','5','#02105C'],
          ['84','21','3.5','#FF3B26'],['74','31','3','#02105C'],['60','42','3.5','#c9a45c'],
          ['90','40','4','#FF3B26']
        ];
        return dots.map(function (d) {
          return '<span class="dot" style="left:'+d[0]+'cqw;top:'+d[1]+'cqw;width:'+d[2]+'cqw;height:'+d[2]+'cqw;background:'+d[3]+'"></span>';
        }).join('');
      }
      case 'wedding':
        return '<span class="ring" style="right:9cqw;top:12cqw;width:20cqw;height:20cqw"></span>' +
               '<span class="ring" style="right:20cqw;top:12cqw;width:20cqw;height:20cqw"></span>';
      case 'baby':
        return '<span class="soft" style="right:10cqw;top:12cqw;width:11cqw;height:11cqw"></span>' +
               '<span class="soft" style="right:22cqw;top:18cqw;width:6cqw;height:6cqw"></span>' +
               '<span class="soft" style="left:10cqw;bottom:14cqw;width:7cqw;height:7cqw;opacity:.4"></span>';
      case 'eid':
        return '<span class="moon"></span>' +
               '<span class="star" style="right:30cqw;top:14cqw"></span>' +
               '<span class="star" style="right:14cqw;top:34cqw"></span>' +
               '<span class="star" style="right:36cqw;top:30cqw;width:1.8cqw;height:1.8cqw"></span>';
      case 'thanks':
        return '<span class="ghost">Merci</span>';
      case 'neon':
        return '<span class="grid"></span><span class="sun"></span><span class="nline"></span>';
      case 'retro':
        return '<span class="r-tri" style="left:69cqw;top:13cqh;width:12cqw;height:12cqw;background:#ff3ca6"></span>'
          + '<span class="r-dia" style="left:85cqw;top:26cqh;width:5cqw;height:5cqw;background:#ffd23f"></span>'
          + '<span class="r-zig" style="left:60cqw;top:40cqh;width:22cqw"></span>'
          + '<span class="r-cir" style="left:90cqw;top:60cqh;width:5cqw;height:5cqw;background:#21e6c1"></span>'
          + '<span class="r-dia" style="left:62cqw;top:62cqh;width:4cqw;height:4cqw;background:#ff3ca6"></span>';
      case 'pop':
        return '<span class="half"></span><span class="pcir"></span><span class="ptri"></span>';
      case 'vapor':
        return '<span class="vgrid"></span><span class="vsun"></span>';
      default:
        return '';
    }
  }

  var ACCENTS = { ink:'#1a1a1a', scarlet:'#FF3B26', navy:'#02105C', coral:'#D9612C' };
  var DT = function (n) { return new Intl.NumberFormat('fr-FR').format(n); };
  function esc(s) { return (s || '').replace(/[<>&]/g, function (c) {
    return { '<':'&lt;', '>':'&gt;', '&':'&amp;' }[c]; }); }

  function initSection(root) {
    if (root.__omesInit) return; root.__omesInit = true;
    var q  = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) {}

    /* amount -> variant id map, from the linked gift-card product's variants.
       Lets the custom-amount box snap to a real variant and charge it exactly. */
    var VMAP = {}, VAMOUNTS = [];
    (function () {
      var el = root.querySelector('[data-gc-variants]');
      if (!el) return;
      var list = [];
      try { list = JSON.parse(el.textContent || '[]'); } catch (e) {}
      list.forEach(function (x) {
        var a = parseInt(x.a, 10), id = String(x.id || '');
        if (!isNaN(a) && id) { VMAP[a] = id; VAMOUNTS.push(a); }
      });
      VAMOUNTS.sort(function (p, q) { return p - q; });
    })();
    function variantFor(a) { return VMAP[a] || ''; }
    function nearestAmount(v) {
      if (!VAMOUNTS.length) return v;
      return VAMOUNTS.reduce(function (best, a) {
        return Math.abs(a - v) < Math.abs(best - v) ? a : best;
      }, VAMOUNTS[0]);
    }

    /* always show the full design list — curation is done by adding/removing
       THEMES, not by a saved count (which can go stale as designs are added) */
    var count = THEMES.length;
    var S = {
      theme: cfg.theme && THEMES.some(function(t){return t.id===cfg.theme;}) ? cfg.theme : THEMES[0].id,
      amount: parseInt(cfg.amount, 10) || 100,
      variant: '',
      recip: '', from: '', message: '', email: '',
      photo: null, delivery: cfg.delivery || 'email'
    };

    /* apply page-level looks */
    root.style.setProperty('--accent', ACCENTS[cfg.accent] || '#1a1a1a');
    root.style.setProperty('--accent-fg', '#ffffff');
    if (cfg.shape && cfg.shape !== 'wallet') root.setAttribute('data-card-shape', cfg.shape);

    var frontCard = q('#gcFront');
    var backCard  = q('#gcBack');
    var railEl    = q('#gcRail');

    /* ---- card markup ---- */
    function themeObj(id) { return THEMES.filter(function (t) { return t.id === id; })[0] || {}; }
    var MARK = '<svg class="gcc__mk" viewBox="0 0 1 1" aria-hidden="true"><use href="#omes-mark"></use></svg>';
    function codeArt(art) {
      if (art === 'diagonal') return '<span class="gcc__panel"></span><svg class="gcc__art gcc__art--diag" viewBox="0 0 1 1"><use href="#omes-mark"></use></svg>';
      if (art === 'pattern') {
        var cells = '';
        for (var r = 0; r < 5; r++) for (var c = 0; c < 7; c++) {
          cells += '<svg class="gcc__pm" style="left:' + (c * 16 - 2) + 'cqw;top:' + (r * 15 - 2) + 'cqw" viewBox="0 0 1 1"><use href="#omes-mark"></use></svg>';
        }
        return '<span class="gcc__pattern">' + cells + '</span>';
      }
      return '<svg class="gcc__art" viewBox="0 0 1 1"><use href="#omes-mark"></use></svg>';
    }
    function frontInner() {
      var th = themeObj(S.theme);
      if (th.code) {
        return ''
          + codeArt(th.art)
          + '<div class="gcc gcc--front">'
          +   '<div class="gcc__top">'
          +     '<span class="gcc__logo">' + MARK + 'omes</span>'
          +     '<span class="gcc__pill"><span data-gc-amt>100</span> DT</span>'
          +   '</div>'
          +   '<div class="gcc__hero">'
          +     '<h3 class="gcc__title">CARTE CADEAU</h3>'
          +     '<p class="gcc__tag">Le cadeau qui laisse le choix.</p>'
          +   '</div>'
          +   '<div class="gcc__foot">Valable sur <b>omes.tn</b></div>'
          + '</div>';
      }
      if (th.img) {
        /* image design: artwork only (buyer photo overlays if any) */
        return ''
          + '<div class="gc__art gc__art--front"></div>'
          + '<div class="gc__photo" data-gc-photo></div><div class="gc__scrim"></div>';
      }
      return ''
        + '<div class="gc__photo" data-gc-photo></div><div class="gc__scrim"></div>'
        + '<div class="gc__motif">' + motif(S.theme) + '</div>'
        + '<div class="gc__inner">'
        +   '<div class="gc__row"><span class="gc__eyebrow">Omes · Tunis</span>'
        +     '<span class="gc__serial">OM · 2026<br>N° 0042</span></div>'
        +   '<div class="gc__mid"><span class="gc__occasion" data-gc-occ></span>'
        +     '<span class="gc__brand">Omes</span></div>'
        +   '<div class="gc__foot">'
        +     '<span class="gc__amount"><span data-gc-amt>100</span><small>DT</small></span>'
        +     '<span class="gc__names" data-gc-names></span></div>'
        + '</div>';
    }
    function backInner() {
      var th = themeObj(S.theme);
      if (th.code) {
        return ''
          + '<span class="gcc__wm">' + '<svg viewBox="0 0 1 1"><use href="#omes-mark"></use></svg>' + '</span>'
          + '<div class="gcc gcc--back">'
          +   '<div class="gcc__top">'
          +     '<span class="gcc__logo">' + MARK + 'omes</span>'
          +     '<span class="gcc__serial">Carte cadeau</span>'
          +   '</div>'
          +   '<div class="gcc__fields">'
          +     '<div class="gcc__row"><span class="gcc__k">Pour</span><span class="gcc__v" data-gc-omes-recip></span></div>'
          +     '<div class="gcc__row"><span class="gcc__k">De</span><span class="gcc__v" data-gc-omes-from></span></div>'
          +     '<div class="gcc__msg" data-gc-omes-note></div>'
          +   '</div>'
          +   '<div class="gcc__redeem"><span><span data-gc-amt>100</span> DT</span><span>Valable sur omes.tn</span></div>'
          + '</div>';
      }
      if (th.img) {
        /* image design: artwork + live handwriting on the printed lines
           (per-theme coords/font live in the CSS, ported from each spec) */
        return ''
          + '<div class="gc__art gc__art--back"></div>'
          + '<div class="gc__photo" data-gc-photo></div><div class="gc__scrim"></div>'
          + '<div class="gc__omes-ov gc__omes-ov--pour" data-gc-omes-recip></div>'
          + '<div class="gc__omes-ov gc__omes-ov--de" data-gc-omes-from></div>'
          + '<div class="gc__omes-ov gc__omes-ov--msg" data-gc-omes-note></div>';
      }
      return ''
        + '<div class="gc__photo" data-gc-photo></div><div class="gc__scrim"></div>'
        + '<div class="gc__motif">' + motif(S.theme) + '</div>'
        + '<div class="gc__inner gc__back">'
        +   '<div class="gc__row"><span class="gc__eyebrow">Un mot pour toi</span>'
        +     '<span class="gc__serial">Carte cadeau</span></div>'
        +   '<p class="gc__note" data-gc-note></p>'
        +   '<div class="gc__redeem"><span data-gc-sign>De ·</span>'
        +     '<span><b>omes.co/cadeau</b></span></div>'
        + '</div>';
    }
    function themeClass(id, photo) { return 'gc t-' + id + (photo ? ' has-photo' : ''); }

    function renderCard() {
      frontCard.className = themeClass(S.theme, S.photo);
      backCard.className  = themeClass(S.theme, S.photo);
      frontCard.innerHTML = frontInner();
      backCard.innerHTML  = backInner();
      var th = themeObj(S.theme);
      /* per-design tokens for code-drawn cards */
      [frontCard, backCard].forEach(function (c) {
        if (!c) return;
        c.style.setProperty('--gc-bg', th.code ? th.bg : '');
        c.style.setProperty('--gc-fg', th.code ? th.fg : '');
        c.style.setProperty('--gc-mark', th.code ? th.mark : '');
      });
      var flipEl = q('#gcFlip');
      if (flipEl) {
        flipEl.classList.toggle('is-img', !!th.img);
        flipEl.classList.toggle('is-code', !!th.code);
        flipEl.style.aspectRatio = th.ratio ? th.ratio : '';
      }
      syncCard();
    }
    function syncCard() {
      var t = THEMES.filter(function (x) { return x.id === S.theme; })[0];
      set('[data-gc-occ]', 'text', t.occ);
      qa('[data-gc-amt]').forEach(function (e) { e.textContent = DT(S.amount); });
      var names = q('[data-gc-names]');
      if (names) names.innerHTML = 'Pour <b>' + (esc(S.recip) || '·') + '</b><br>De <b>' + (esc(S.from) || '·') + '</b>';
      set('[data-gc-note]', 'text', S.message || 'Un petit mot, pour une bonne journée. Prends ton temps pour choisir.');
      set('[data-gc-sign]', 'text', 'De ' + (S.from || '·'));
      /* omes crème overlay — handwriting on the printed lines (no-ops on other themes) */
      set('[data-gc-omes-recip]', 'text', S.recip || '');
      set('[data-gc-omes-from]', 'text', S.from || '');
      set('[data-gc-omes-note]', 'text', S.message || '');
      qa('[data-gc-photo]').forEach(function (ph) { ph.style.backgroundImage = S.photo ? 'url(' + S.photo + ')' : ''; });
      set('#gcTotal', 'text', DT(S.amount));
      set('#gcMetaValue', 'text', DT(S.amount) + ' DT');
      // hidden cart fields
      setVal('#gcPropMontant', S.amount + ' DT');
      setVal('#gcVariant', S.variant);
    }
    function set(sel, kind, v) { var e = q(sel); if (e) e[kind === 'text' ? 'textContent' : 'innerHTML'] = v; }
    function setVal(sel, v) { var e = q(sel); if (e) e.value = v; }

    /* ---- rail ---- */
    function thumbCard(id) {
      /* fixed-ratio box + absolutely-filled card so content can never change the
         thumb height (consistent size across all themes / host environments) */
      var inner;
      var th = themeObj(id);
      if (th.code) {
        inner = '<div class="gc t-' + id + ' thumb__fill thumb__fill--code" style="--gc-bg:' + th.bg + ';--gc-fg:' + th.fg + ';--gc-mark:' + th.mark + '">'
          + codeArt(th.art)
          + '<div class="gcc gcc--thumb"><span class="gcc__logo">' + MARK + 'omes</span>'
          + '<h3 class="gcc__title">CARTE<br>CADEAU</h3></div></div>';
      } else if (th.img) {
        inner = '<div class="gc t-' + id + ' thumb__fill"><div class="gc__art gc__art--front"></div></div>';
      } else {
        inner = '<div class="gc t-' + id + ' thumb__fill"><div class="gc__motif">' + motif(id) + '</div>'
          + '<div class="gc__inner" style="justify-content:center;align-items:center;padding:0">'
          + '<span class="gc__brand" style="font-size:22cqw">Omes</span></div></div>';
      }
      return '<div class="thumb__box">' + inner + '</div>';
    }
    function renderRail() {
      railEl.innerHTML = '';
      THEMES.slice(0, count).forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'thumb' + (t.id === S.theme ? ' on' : '');
        b.setAttribute('data-theme', t.id);
        b.innerHTML = thumbCard(t.id) + '<div class="thumb__lbl"><span>' + t.name + '</span><small>' + t.tag + '</small></div>';
        b.addEventListener('click', function () {
          S.theme = t.id; setVal('#gcPropStyle', t.name);
          renderRail(); renderCard(); updateCaption();
        });
        railEl.appendChild(b);
      });
      set('#gcStyleCount', 'text', count + ' styles');
    }
    function updateCaption() {
      var t = THEMES.filter(function (x) { return x.id === S.theme; })[0];
      set('#gcCapName', 'text', t.name);
      set('#gcCapTag', 'text', S.photo ? 'votre photo' : t.tag.toLowerCase());
    }

    /* ---- amount ---- */
    var denoms = qa('.gc-denom');
    denoms.forEach(function (d) {
      d.addEventListener('click', function () {
        denoms.forEach(function (x) { x.classList.remove('on'); });
        d.classList.add('on');
        S.amount = parseInt(d.getAttribute('data-amount'), 10);
        S.variant = variantFor(S.amount) || d.getAttribute('data-variant') || '';
        var ci = q('#gcCustom'); if (ci) ci.value = '';
        syncCard();
      });
      if (parseInt(d.getAttribute('data-amount'), 10) === S.amount) {
        d.classList.add('on'); S.variant = variantFor(S.amount) || d.getAttribute('data-variant') || '';
      }
    });
    var custom = q('#gcCustom');
    if (custom) {
      var snapCustom = function () {
        var v = parseInt(custom.value, 10); if (isNaN(v)) return;
        var min = parseInt(cfg.min, 10) || 20, max = parseInt(cfg.max, 10) || 2000;
        v = Math.max(min, Math.min(max, v));
        // snap to the nearest real variant so the charge is always exact
        var a = nearestAmount(v);
        S.amount = a;
        denoms.forEach(function (x) {
          x.classList.toggle('on', parseInt(x.getAttribute('data-amount'), 10) === a);
        });
        S.variant = variantFor(a) || cfg.customVariant || '';
        syncCard();
      };
      custom.addEventListener('input', snapCustom);
      // on blur, reflect the snapped (actually charged) amount back into the field
      custom.addEventListener('change', function () {
        if (custom.value !== '') custom.value = S.amount;
      });
    }

    /* ---- fields ---- */
    bind('#gcRecip', function (v) { S.recip = v; });
    bind('#gcFrom', function (v) { S.from = v; });
    bind('#gcEmail', function (v) { S.email = v; });
    var msg = q('#gcMessage');
    if (msg) msg.addEventListener('input', function () {
      S.message = msg.value; syncCard();
      set('#gcMsgCount', 'text', msg.value.length + ' / 220');
    });
    function bind(sel, fn) { var el = q(sel); if (el) el.addEventListener('input', function () { fn(el.value); syncCard(); }); }

    /* ---- upload (preview only; the same file input posts to Shopify) ---- */
    var input = q('#gcUpload'), nameEl = q('#gcUploadName'), clear = q('#gcUploadClear');
    if (input) input.addEventListener('change', function () {
      var f = input.files && input.files[0]; if (!f) return;
      if (f.size > 6 * 1024 * 1024) { if (nameEl) nameEl.textContent = 'Trop lourd (max 6 Mo)'; input.value = ''; return; }
      var r = new FileReader();
      r.onload = function () { S.photo = r.result; if (nameEl) nameEl.textContent = f.name; if (clear) clear.hidden = false; renderCard(); updateCaption(); };
      r.readAsDataURL(f);
    });
    if (clear) clear.addEventListener('click', function () {
      S.photo = null; if (input) input.value = ''; if (nameEl) nameEl.textContent = 'Aucune image';
      clear.hidden = true; renderCard(); updateCaption();
    });

    /* ---- flip ---- */
    var flip = q('#gcFlip');
    qa('.flipper button').forEach(function (b) {
      b.addEventListener('click', function () {
        qa('.flipper button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        if (flip) flip.classList.toggle('is-back', b.getAttribute('data-face') === 'back');
      });
    });

    /* ---- delivery ---- */
    qa('.deliv__opt').forEach(function (o) {
      o.addEventListener('click', function () {
        qa('.deliv__opt').forEach(function (x) { x.classList.remove('on'); });
        o.classList.add('on');
        S.delivery = o.getAttribute('data-delivery');
        set('#gcMetaDelivery', 'text', S.delivery === 'email' ? 'E-mail' : 'Imprimée');
        setVal('#gcPropDelivery', S.delivery === 'email' ? 'E-mail' : 'Imprimée');
        var sched = q('#gcSched'); if (sched) sched.style.display = S.delivery === 'email' ? 'grid' : 'none';
      });
      if (o.getAttribute('data-delivery') === S.delivery) o.classList.add('on');
    });

    /* ---- submit (native multipart → Shopify cart) ---- */
    var form = q('#gcForm');
    if (form) form.addEventListener('submit', function (e) {
      if (!S.variant) {
        e.preventDefault();
        alert('Cette boutique n\u2019a pas encore de produit carte cadeau relié à ce montant. Reliez les variantes dans les réglages de la section.');
        return;
      }
      if (!S.recip || !S.recip.trim()) {
        e.preventDefault();
        var r = q('#gcRecip'); if (r) { r.focus(); r.classList.add('txt--err'); }
        return;
      }
      // sync hidden fields one last time; let the form submit natively (handles file)
      syncCard();
      setVal('#gcPropOccasion', (THEMES.filter(function(x){return x.id===S.theme;})[0]||{}).occ || '');
      var btn = q('#gcAdd'); if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
    });

    if (!S.variant) S.variant = variantFor(S.amount);
    renderCard();
    renderRail();
    updateCaption();
    setVal('#gcPropStyle', (THEMES.filter(function(x){return x.id===S.theme;})[0]||{}).name || '');
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('.omes-gc')).forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', boot);
})();
